const {Component} = require("react");
const PropTypes = require("prop-types");
const {classList} = require("helpers/html");
const userStore = require("stores/UserStore");
const router = require("services/router");
const moment = require("moment");
const {pluckKeysExcept} = require("helpers/object");
const {isSent, isRead} = require("components/backend/chat/Message");
const {renderEmoji} = require("helpers/renderEmoji");

class Channel extends Component {

	static get propTypes() {
		return {
			// Channel model
			id: PropTypes.number.isRequired,
			members: PropTypes.array.isRequired,
			status: PropTypes.string.isRequired,
			last_activity_at: PropTypes.any,

			// Additional model data
			messages: PropTypes.array,

			// State props
			active: PropTypes.bool,

			// Configuration props
			defaultAvatarUrl: PropTypes.string,
			messageTruncateLength: PropTypes.number
		};
	}

	static get defaultProps() {
		return {
			messageTruncateLength: 40,
			defaultAvatarUrl: "img/avatar-placeholder.png",
			active: false
		};
	}


	/////////////////////////////////
	// Helpers
	/////////////////////////////////

	truncateContents(contents) {
		return contents.length > this.props.messageTruncateLength ?
			contents.substr(0, this.props.messageTruncateLength - 3) + "..." :
			contents;
	}

	/////////////////////////////////
	// Accessors
	/////////////////////////////////

	get latestMessage() {
		return this.props.messages.length > 0 ?
			this.props.messages[this.props.messages.length - 1] :
			null;
	}

	get hasUnreadMessages() {
		for (let i = 0; i < this.props.messages.length; i++) {
			if (!isSent(this.props.messages[i]) && !isRead(this.props.messages[i])) {
				return true;
			}
		}

		return false;
	}

	get className() {
		return classList(
			"message",
			this.props.active && "active",
			this.hasUnreadMessages && "new"
		);
	}

	get partner() {
		return this.props.members.filter(member => member.id !== userStore.get("id")) [0];
	}

	get customProps() {
		return pluckKeysExcept(this.props, Object.keys(this.constructor.propTypes));
	}

	get content() {
		const message = this.latestMessage;

		if (message == undefined) {
			return;
		}

		let sender = this.getSender(message);

		return sender + renderEmoji(message.contents, true);
	}

	getSender(message) {

		if (message.sender && message.sender.id) {
			if (message.sender.id === userStore.get('id')) {
				return 'Dig: ';

			}

			if (message.sender.nickname) {
				return message.sender.nickname + ': ';
			}
		}

		return '';
	}

	get message() {
		return {__html: this.content};
	}

	/////////////////////////////////
	// Rendering
	/////////////////////////////////

	renderAvatar() {
		const partner = this.partner;
		const avatarUrl = partner.avatar ? partner.avatar.url : router.url(this.props.defaultAvatarUrl);

		return (
			<div className="img-box object-fit">
				<img src={avatarUrl} alt={partner.nickname}/>
			</div>
		);
	}

	render() {
		const partner = this.partner;
		const lastActivityAt = this.props.last_activity_at ?
			moment(this.props.last_activity_at).format("HH:mm") :
			null;

		return (
			<div className={this.className} {...this.customProps}>
				{this.renderAvatar()}
				<div className="message-box">
					<div className="message-topbar">
						<p className="name">{partner.nickname}</p>
						<p className="time">{lastActivityAt}</p>
					</div>
					<p className="msg" dangerouslySetInnerHTML={this.message}></p>
				</div>
			</div>
		);
	}

}

module.exports = {
	Channel
};



// WEBPACK FOOTER //
// ./resources/js/components/backend/chat/Channel.js